// extracted by mini-css-extract-plugin
module.exports = {"root":"AuthLayout_root__1JjIU","logo":"AuthLayout_logo__Qo5SW","media":"AuthLayout_media__1oLwA","auth":"AuthLayout_auth__31c60","formWrapper":"AuthLayout_formWrapper__2algm"};